import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export interface SvgIconCaretProps extends SvgIconProps {
	type: "up" | "right" | "down" | "left";
}

export default function SvgIconCaret({
	type,
	className,
	...props
} : SvgIconCaretProps) {
	let d, width, height;
	switch(type) {
		case "up":
			width = 100;
			height = 50;
			d = "M0.633308 49.9741C0.152294 50.1315 -0.214254 49.5347 0.143619 49.1769L49.1796 0.140878C49.3674 -0.0469584 49.672 -0.0469621 49.8598 0.140874L98.8958 49.1769C99.2537 49.5347 98.8871 50.1315 98.4061 49.9741L49.6693 34.0267C49.5721 33.9949 49.4673 33.9949 49.3701 34.0267L0.633308 49.9741Z";
			break;
		case "right":
			width = 50;
			height = 100;
			d = "M0.0261558 0.63945C-0.132766 0.153772 0.469785 -0.216332 0.831129 0.145012L50.3427 49.6566C50.5324 49.8463 50.5324 50.1537 50.3427 50.3434L0.831125 99.855C0.46978 100.216 -0.13277 99.8462 0.0261516 99.3605L16.1283 50.151C16.1604 50.0529 16.1604 49.9471 16.1283 49.849L0.0261558 0.63945Z";
			break;
		case "down":
			width = 100;
			height = 50;
			d = "M98.8864 0.0259045C99.3674 -0.13149 99.734 0.465272 99.3761 0.823145L50.3401 49.8591C50.1523 50.047 49.8477 50.047 49.6599 49.8591L0.623909 0.823137C0.266036 0.465263 0.632585 -0.131499 1.1136 0.025896L49.8504 15.9733C49.9476 16.0051 50.0524 16.0051 50.1496 15.9733L98.8864 0.0259045Z";
			break;
		case "left":
			width = 50;
			height = 100;
			d = "M51.2163 99.3606C51.3752 99.8462 50.7727 100.216 50.4113 99.855L0.899758 50.3434C0.7101 50.1537 0.710096 49.8462 0.899754 49.6566L50.4113 0.145015C50.7727 -0.21633 51.3752 0.153774 51.2163 0.639453L35.1142 49.849C35.0821 49.9471 35.0821 50.0529 35.1142 50.151L51.2163 99.3606Z";
			break;
	}
	return (
		<SvgIcon
			width={width}
			height={height}
			className={cn(
				styles.SvgIconCaret,
				styles[`SvgIconCaret_${type}`],
				className
			)}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				fill="currentColor"
				d={d}
				// d="M0.633308 49.9741C0.152294 50.1315 -0.214254 49.5347 0.143619 49.1769L49.1796 0.140878C49.3674 -0.0469584 49.672 -0.0469621 49.8598 0.140874L98.8958 49.1769C99.2537 49.5347 98.8871 50.1315 98.4061 49.9741L49.6693 34.0267C49.5721 33.9949 49.4673 33.9949 49.3701 34.0267L0.633308 49.9741Z"
			/>
		</SvgIcon>
	)
}
